/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Voice_Manager_Preview_LabelInputs */

const en_voice_manager_preview_label = /** @type {(inputs: Voice_Manager_Preview_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preview ${i?.name}`)
};

const fr_voice_manager_preview_label = /** @type {(inputs: Voice_Manager_Preview_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Apercu ${i?.name}`)
};

const de_voice_manager_preview_label = /** @type {(inputs: Voice_Manager_Preview_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vorschau ${i?.name}`)
};

const it_voice_manager_preview_label = /** @type {(inputs: Voice_Manager_Preview_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anteprima ${i?.name}`)
};

const ru_voice_manager_preview_label = /** @type {(inputs: Voice_Manager_Preview_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр ${i?.name}`)
};

const es_voice_manager_preview_label = /** @type {(inputs: Voice_Manager_Preview_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vista previa ${i?.name}`)
};

const zh_cn2_voice_manager_preview_label = /** @type {(inputs: Voice_Manager_Preview_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`预览 ${i?.name}`)
};

const ja_voice_manager_preview_label = /** @type {(inputs: Voice_Manager_Preview_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プレビュー ${i?.name}`)
};

const hi_voice_manager_preview_label = /** @type {(inputs: Voice_Manager_Preview_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`पूर्वावलोकन ${i?.name}`)
};

const pt_pt2_voice_manager_preview_label = /** @type {(inputs: Voice_Manager_Preview_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pré-visualização ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Preview {name}" |
*
* @param {Voice_Manager_Preview_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_preview_label = /** @type {((inputs: Voice_Manager_Preview_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Preview_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_preview_label(inputs)
	if (locale === "de") return de_voice_manager_preview_label(inputs)
	if (locale === "it") return it_voice_manager_preview_label(inputs)
	if (locale === "ru") return ru_voice_manager_preview_label(inputs)
	if (locale === "es") return es_voice_manager_preview_label(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_preview_label(inputs)
	if (locale === "ja") return ja_voice_manager_preview_label(inputs)
	if (locale === "hi") return hi_voice_manager_preview_label(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_preview_label(inputs)
	return en_voice_manager_preview_label(inputs)
});